export default __webpack_public_path__ + "build/3f37c1ca54fad8afbcdd3f4743cf194d.svg";